<template>
  <div id="support-main">
    <div class="support-heading">
      <h2>How can we help?</h2>
      <h3>Help with a recent order</h3>
      <p>View your order history to get in contact with the Restaurant you ordered from.</p>
      <div class="support-button" @click="$router.push({name: 'orders'})">
        {{ isLoggedIn ? 'View Order History' : 'Log in to see your order history' }}
      </div>
    </div>

    <div v-if="isLoggedIn" class="recent-orders-wrap">
      <h2>Your Recent Orders</h2>
      <div v-if="orderListData" class="recent-orders-list">
        <orders :recent="true" />
      </div>
    </div>
  </div>
</template>
<script>
import Orders from './Orders'
export default {
  props: {
    restaurant_id: {
      type: String
    }
  },
  components: {
    Orders
  },
  computed: {
    orderList () {
      return this.$store.state.api.orderList.filter((x) => { return x.total_amount > 0 })
    },
    isLoggedIn () {
      return this.$store.state.api.token_valid
    }
  },
  data () {
    return {
      orderListData: null
    }
  },
  mounted () {
    if (this.orderList.length === 0) {
      this.getOrderList()
    } else {
      this.orderListData = this.orderList.reverse()
    }
  },
  watch: {
  },
  methods: {
    getOrderList () {
      this.$store.dispatch('api/orderList')
        .then(() => {
          this.orderListData = this.orderList.reverse().slice(0, 5)
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  }
}
</script>

<style lang="scss">
#support-main{
  width:100%;
}
.support-heading *{
margin-bottom:20px;

}
.support-heading {
  h2{
font-size:22px;
font-weight: 900;
}
h3{
  font-size:18px;
  font-weight: 900;
}
}
.support-button{
  background-color:#13aa37;
  color:#fff;
  padding:5px 10px;
  width:max-content;
  cursor:pointer;
  border-radius: 7px;
}
.recent-orders-list {
  margin-top:20px;
}
@media (max-width:768px){
  #support-main{
    padding:0px 20px;
  }
}
</style>
